<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section>
      <div class="card">
        <div class="card-title w-100 pt-2 px-2 pb-0 mb-0">
          <div class="row">
            <div class="col-xl-3 col-12" [ngClass.sm]="'mb-1'">
              <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control" autocomplete="off" [(ngModel)]="searchKey" (ngModelChange)="searchCommission()" />
            </div>
            <div class="col-xl-3 col-12" [ngClass.sm]="'mb-1'">
              <ng-select [(ngModel)]="filter_customer" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false" (ngModelChange)="searchCommission()">
                <ng-option [value]="0">
                  <span class="font-small-4 font-weight-normal pr-2">{{ "CUSTOMER" | translate }}</span>
                </ng-option>
                <ng-option [value]="customer.id" *ngFor="let customer of customers_list">
                  <span class="font-small-4 font-weight-normal pr-2">{{ customer.name }}</span>
                </ng-option>
              </ng-select>
            </div>
            <div class="col-xl-6 text-right" [ngClass.sm]="'col-12 mt-1'">
              <div [ngClass.xl]="'d-inline-block'" *ngIf="_utilService.isDesktop">
                <app-select-table-limit [defaultValue]="tableLimit" (onChange)="tableLimit = $event"></app-select-table-limit>
              </div>
            </div>
          </div>
        </div>

        <!--desktop-->
        <div class="card-body px-0 pb-0">
          <ngx-datatable
            class="bootstrap core-bootstrap"
            columnMode="force"
            [headerHeight]="30"
            [scrollbarH]="true"
            [rowHeight]="_utilService.isDesktop ? 70 : 350"
            [limit]="tableLimit"
            [footerHeight]="50"
            [rows]="filterList"
            [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          >
            <ngx-datatable-column [name]="'CUSTOMER' | translate" prop="client.name" width="300" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <a class="text-break-line-2" [ngbTooltip]="row.client.name" [routerLink]="'/dashboard/customer/' + row.client.id">{{ row.client.name ? row.client.name : "-" }}</a>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'COMMISSION' | translate" prop="complete_name" width="300" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <a class="text-break-line-2" [ngbTooltip]="row.complete_name" [routerLink]="'/dashboard/commission/edit/' + row.id" [queryParams]="{ tab_name: 'economic' }" target="_blank">{{
                    row.complete_name ? row.complete_name : "-"
                  }}</a>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'TOTAL_COSTS' | translate" prop="complete_name" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">{{ (row.analytics?.real_cost || 0) | currency: 'EUR' }}</div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'TOTAL_REVENUE' | translate" prop="complete_name" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">{{ (row.analytics?.real_profit || 0) | currency: 'EUR' }}</div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'PERCENTAGE_MARGIN' | translate" prop="margin_percentage" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">{{ row.analytics?.margin_percentage }} %</div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'EURO_MARGIN' | translate" prop="margin_currency" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">{{ row.analytics?.margin_currency ? _utilService.addDotsToNumber(row.analytics?.margin_currency) : "-" }} €</div>
              </ng-template>
            </ngx-datatable-column>
            <!--mobile - tablet-->
            <ngx-datatable-column [name]="'NAME' | translate" prop="complete_name" *ngIf="!_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="col-12 list-item-mobile pl-0">
                  <div>
                    <a [ngbTooltip]="row.client.name" [routerLink]="'/dashboard/customer/' + row.client.id">{{ row.client.name ? row.client.name : "-" }}</a>
                  </div>
                  <div>
                    <a [routerLink]="'/dashboard/commission/edit/' + row.id" [queryParams]="{ tab_name: 'economic' }" target="_blank">{{ row.complete_name }}</a>
                  </div>
                  <div>
                    <span>{{ "TOTAL_COSTS" | translate }}: </span>
                    <span>{{ (row.analytics?.real_cost || 0) | currency:'EUR'}}</span>
                  </div>
                  <div>
                    <span>{{ "TOTAL_REVENUE" | translate }}: </span>
                    <span>{{ (row.analytics.real_profit || 0) | currency:'EUR' }}</span>
                  </div>
                  <div>
                    <span>{{ "PERCENTAGE_MARGIN" | translate }}: </span>
                    <span>{{ row.analytics?.margin_percentage }} %</span>
                  </div>
                  <div>
                    <span>{{ "EURO_MARGIN" | translate }}: </span>
                    <span>{{ row.analytics?.margin_currency ? _utilService.addDotsToNumber(row.analytics?.margin_currency) : "-" }} €</span>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
          <div class="p-1">{{ "TOTAL_COSTS" | translate }}: {{ _utilService.addDotsToNumber(totalCost) }}€</div>
          <div class="px-1 pb-1">{{ "TOTAL_REVENUE" | translate }}: {{ _utilService.addDotsToNumber(totalRevenue) }}€</div>
        </div>
      </div>
    </section>
  </div>
</div>
